import type { PropsWithChildren } from "react";
import { Text, Tooltip, type TextProps } from "@chakra-ui/react";
import { Link, useParams } from "react-router-dom";
import { VENDOR_PORTAL_PATHS } from "modules/vendor-portal/paths";
import type { FeedbackLocationState } from "modules/vendor-portal/screens/feedback/feedback-screen";
import {
  FeedbackGroupByOption,
  type NumberFilter,
} from "modules/vendor-portal/screens/feedback/utils";

export function StatisticLink({
  children,
  numberFilter,
  ...rest
}: PropsWithChildren<{
  numberFilter: NumberFilter;
}> &
  TextProps) {
  const { regionId, propertyId } = useParams();

  return (
    <Tooltip label={"Click to view buyers"} placement={"top"} hasArrow>
      <Text
        as={Link}
        to={`/${regionId}/listing/${propertyId}/${VENDOR_PORTAL_PATHS.FEEDBACK}`}
        state={
          {
            groupBy: FeedbackGroupByOption.Date,
            showOnly: {
              key: "price_indication",
              value: numberFilter,
            },
          } satisfies FeedbackLocationState
        }
        fontSize={"md"}
        fontWeight={500}
        color={"blue.600"}
        w={"fit-content"}
        {...rest}
      >
        {children}
      </Text>
    </Tooltip>
  );
}
